<div class="container-block-map">
    <aside class="block-schedule">
        <rwidget-plan-ride
            [selectedPickup]="pickup"
            [selectedDropoff]="dropOff"
            (onSubmit)="handleSubmit($event)"
            (onSelectedPickup)="onFormDeparture($event)"
            (onSelectedDropoff)="onFormDestination($event)">
        </rwidget-plan-ride>
    </aside>

    <div class="block-schedule-map" [ngClass]="isFullMap ? 'full-map' : ''">
        <div class="show-mobile hide-desktop">
            <div class="map-overlay-mobile" [ngClass]="{ hidden: isFullMap }" (click)="toggleMapSize()"></div>
        </div>

        <div class="flex-center" *ngIf="isFullMap">
            <button class="increase-map" (click)="toggleMapSize()">
                <span *ngIf="!isFullMap">{{ 'SCHEDULE_MAP_INCREASE_TITLE' | translate }}</span>
                <span *ngIf="isFullMap">{{ 'SCHEDULE_MAP_DECREASE_TITLE' | translate }}</span>
            </button>
        </div>
        <rwidget-map
            [latitude]="mapCenter.latitude"
            [longitude]="mapCenter.longitude"
            [hasControls]="false"
            [allowPointClick]="!(env.ONDEMAND?.DISABLE_ALLOW_POINT_CLICK === true)"
            [fullMap]="isFullMap"
            (pointClicked)="onPointClicked($event)">
            <rwidget-map-popup [coordinates]="selectedPoint" [minWidth]="300">
                <div class="popup-title text-base" *ngIf="selectedPoint">
                    <p>{{ selectedPoint.address }}</p>
                </div>
                <ridango-ui-basic-loading-spinner *ngIf="!selectedLocation"></ridango-ui-basic-loading-spinner>
                <mat-nav-list class="remove-padding" *ngIf="selectedLocation">
                    <mat-list-item (click)="onMapDeparture()">
                        <div mat-line>{{ 'PICKUP' | translate }}</div>
                        <mat-icon>chevron_right</mat-icon>
                    </mat-list-item>
                    <mat-divider></mat-divider>
                    <mat-list-item (click)="onMapDestination()">
                        <div mat-line>{{ 'DROPOFF' | translate }}&nbsp;</div>
                        <mat-icon>chevron_right</mat-icon>
                    </mat-list-item>
                </mat-nav-list>
            </rwidget-map-popup>

            <rwidget-map-marker *ngIf="pickup" [latitude]="pickup.lat" [longitude]="pickup.lon" [isSingle]="true">
                <rwidget-map-icon [url]="iconOrigin" [size]="[18, 24]" [anchor]="[9, 24]"></rwidget-map-icon>
            </rwidget-map-marker>

            <rwidget-map-marker *ngIf="dropOff" [latitude]="dropOff.lat" [longitude]="dropOff.lon" [isSingle]="true">
                <rwidget-map-icon [url]="iconDestination" [size]="[24, 24]"></rwidget-map-icon>
            </rwidget-map-marker>

            <rwidget-map-layer-group [label]="'SCHEDULE_STOPS_LAYER' | translate" [showOnMap]="true">
                <rwidget-map-marker-group
                    [markers]="potentialStops$ | async"
                    [deleteOld]="true"
                    (markerClicked)="onStopClicked($event)">
                    <rwidget-map-icon [url]="iconStop" [anchor]="[18, 44]" [size]="[36, 44]"> </rwidget-map-icon>
                    <rwidget-map-popup>
                        <div class="popup-title text-base">
                            <p>
                                {{ clickedStop?.address }}
                                <ng-container *ngIf="clickedStop?.direction">
                                    ({{ clickedStop.direction }})
                                </ng-container>
                            </p>
                        </div>
                        <mat-nav-list class="remove-padding">
                            <mat-list-item (click)="onDepartureClicked(clickedStop)">
                                <div mat-line>{{ 'SCHEDULE_SET_AS_DEPARTURE' | translate }}</div>
                                <mat-icon>chevron_right</mat-icon>
                            </mat-list-item>
                            <mat-divider></mat-divider>
                            <mat-list-item (click)="onDestinationClicked(clickedStop)">
                                <div mat-line>{{ 'SCHEDULE_SET_AS_DESTINATION' | translate }}</div>
                                <mat-icon>chevron_right</mat-icon>
                            </mat-list-item>
                        </mat-nav-list>
                    </rwidget-map-popup>
                </rwidget-map-marker-group>
            </rwidget-map-layer-group>

            <rwidget-map-locator></rwidget-map-locator>
        </rwidget-map>
    </div>
</div>
